// extracted by mini-css-extract-plugin
export default {"container_page":"start-page_container_page__8zuru","gender_text":"start-page_gender_text__Xy4WY","subtitle":"start-page_subtitle__dm0Wh"};